import { Plugin, icons } from 'ckeditor5/src/core';
import { ButtonView } from 'ckeditor5/src/ui';
import { WidgetToolbarRepository } from 'ckeditor5/src/widget';
import { isWidget } from 'ckeditor5/src/widget';
import { createNewButtons} from '../blocks/blocks-utils'
const iconsMap = new Map( [
	[ 'left', icons.alignLeft ],
	[ 'right', icons.alignRight ],
	[ 'upload', icons.image ]
] );

export default class MovieAndTextBoxToolbar extends Plugin {

	static get requires() {
		return [ WidgetToolbarRepository ];
	}

	static get pluginName() {
		return 'MovieAndTextBoxToolbar';
	}


	afterInit() {
		const editor = this.editor;
		const t = editor.t;
		const widgetToolbarRepository = editor.plugins.get( WidgetToolbarRepository );

		const options = [
			{
				name: 'movieAndTextLeft',
				label: 'Movie on the left side',
				command: 'movieAndTextAlignment',
				commandValue: 'left',
				type: 'action'
			},
			{
				name: 'movieAndTextRight',
				label: 'Movie on the right side',
				command: 'movieAndTextAlignment',
				commandValue: 'right',
				type: 'action'
			}
		]
		createNewButtons(this, options);
		const optionsCommand = options.map(option => {
				if(option.commandValue){
					return `${option.command}:${option.commandValue}`;
				}else {
					return option.command;
				}
			});
		if ( options ) {
			widgetToolbarRepository.register( 'MovieAndTextContent', {
				ariaLabel: t( 'Movie and text box toolbar' ),
				items: optionsCommand,
				getRelatedElement: getSelectedMovieAndTextWidget,
				balloonClassName: 'ck-custom-fieldset-toolbar'
			} );
		}
	}
}

export function getSelectedMovieAndTextWidget( selection ) {
	const viewElement = selection.getSelectedElement();

	if ( viewElement && isMovieAndTextWidget( viewElement ) ) {
		return viewElement;
	}

	return null;
}

export function getMovieAndTextWidgetAncestor( selection ) {
	const selectionPosition = selection.getFirstPosition();

	if ( !selectionPosition ) {
		return null;
	}

	let parent = selectionPosition.parent;

	while ( parent ) {
		if ( parent.is( 'element' ) && isMovieAndTextWidget( parent ) ) {
			return parent;
		}

		parent = parent.parent;
	}

	return null;
}

function isMovieAndTextWidget( viewElement ) {
	return !!viewElement.hasClass( 'movie-and-text-box') && isWidget(viewElement);
}

